export default {
  send: 'Send Message',
  unread_delimiter: 'Unread messages'
};
